import React, { useState } from 'react'
import { Dialog, DialogActions, DialogTitle, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone'
import SnackBarUtils from '../../../../utils/SnackBarUtils'

interface Props {
  open: boolean
  setOpen: (op: boolean) => void
  datos: any
}

const DatosTransferencia: React.FC<Props> = ({ open, setOpen, datos }: Props) => {
  const [aliasCopiado, setAliasCopiado] = useState<boolean>(false)
  const [nroCopiado, setnroCopiado] = useState<boolean>(false)

  const handleClose = () => {
    setOpen(false)
    setAliasCopiado(false)
    setnroCopiado(false)
  }

  const handleCopyAlias = () => {
    setAliasCopiado(true)
    setnroCopiado(false)
    navigator.clipboard.writeText(datos.alias)
    SnackBarUtils.success('Alias copiado')
  }

  const handleCopyNro = () => {
    setnroCopiado(true)
    setAliasCopiado(false)
    navigator.clipboard.writeText(datos.nroCuenta)
    SnackBarUtils.success(`${datos.tipoCuenta} copiado`)
  }

  if (!datos) return <></>
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          overflowX: 'hidden'
        }
      }}
    >
      <DialogTitle style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold' }} variant="h5">
        Datos de transferencia
      </DialogTitle>
      <Box sx={{ margin: '30px 30px 10px 30px', display: 'flex', flexDirection: 'row', gap: '10px' }}>
        <Typography variant="h6">
          <strong>{datos.tipoCuenta}: </strong>
          {datos.nroCuenta}
        </Typography>
        <ContentCopyTwoToneIcon
          sx={{ cursor: 'pointer', marginTop: '6px' }}
          onClick={handleCopyNro}
          color={nroCopiado ? 'primary' : 'action'}
          titleAccess="Copiar"
        />
      </Box>
      <Box
        sx={{ margin: '30px 30px 10px 30px', display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '10px' }}
      >
        <Typography variant="h6">
          <strong>Alias: </strong>
          {datos.alias}
        </Typography>
        <ContentCopyTwoToneIcon
          sx={{ cursor: 'pointer', marginTop: '6px' }}
          onClick={handleCopyAlias}
          color={aliasCopiado ? 'primary' : 'action'}
          titleAccess="Copiar Alias"
        />
      </Box>
      {datos.monto && (
        <Box
          sx={{ margin: '30px 30px 10px 30px', display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '10px' }}
        >
          <Typography variant="h6">
            <strong>Monto: </strong>
            {datos.monto}
          </Typography>
        </Box>
      )}
      <DialogActions>
        <IconButton
          edge="end"
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '16px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogActions>
    </Dialog>
  )
}

export default DatosTransferencia
